import axios from 'axios';

// console.log('base api url', process.env.VUE_APP_BASE_API);

const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 5000 // request timeout
}); 

// request interceptor 请求拦截器
service.interceptors.request.use(
    config => {
        const token = window.sessionStorage.getItem('token') ? window.sessionStorage.getItem('token') : window.localStorage.getItem('token') ;
        if(token) {
            config.headers['token'] = `${token}`;
        }
        // config.headers["Access-Control-Allow-Origin"]="*";
        return config
    },
    error => {
        return Promise.reject(error)
    }
);

// response interceptor 响应拦截器
service.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
     */

    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    response => {
        const res = response.data;
        if (res.code !== 0) {
            const errorMsg = {
                "-4": "无访问权限"
            };
            if(res.code === -1) {
                // store.dispatch("user/logout", {}).then(() => {
                // });
            }
            // return Promise.reject(errorMsg[res.code] || res.msg || 'Error');response
            return Promise.reject(res);
        } else {
            return res;
        }
    },
    error => {
        if(error.response.data.msg === 'token过期，请重新登录' || error.response.data.msg === 'token不存在，请重新登录') {
            axios({
                headers: {
                    token: window.sessionStorage.getItem('token') || window.localStorage.getItem('token')
                },
                method: 'get',
                url: process.env.VUE_APP_BASE_API + 'user/resetToken',
                data: {
                    token: window.sessionStorage.getItem('token') || window.localStorage.getItem('token')
                }
            }).then(res => {
                if(window.sessionStorage.getItem('token')) {
                    window.sessionStorage.setItem('token', res.data.data.token)
                } else {
                    window.localStorage.setItem('token', res.data.data.token)
                }
                console.log('更新token')
                this.$router.go(0);
            })
        }
        // Message({
        //     message: error.message,
        //     type: 'error',
        //     duration: 5 * 1000
        // });
        return Promise.reject(error.response.data);
    }
);

export default service